import { useEffect, useState } from "react";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../../shared-components/Button";

import { Modal } from "../../shared-components/Modal";
import { usePermissionValidator } from "../../api/UserPermissionValidators";
import { useCreateReportNote, useGetReportsNotes } from "../../api/ReportsApi";
import ReportNote from "../ReportNotes";
import AddNoteModal from "../AddNoteModal";
import { HARDCODED_ACTOR_UUID } from "../../api/helpers";
import { ReportSummaryItemApi } from "../../api/Reports";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import { classNames, LONG_TEXT_WRAP_CLASSES } from "../../utils";

type NotesProps = {
  isReadOnly: boolean;
  report: ReportSummaryItemApi;
};

function Notes({ isReadOnly, report }: NotesProps) {
  const { canAddNotes } = usePermissionValidator();
  const [isReportNoteModalOpen, setIsReportNoteModalOpen] = useState(false);
  const {
    isLoading: notesLoading,
    data: notes,
    mutate: getNotes,
  } = useGetReportsNotes();
  const [showAllNotes, setShowAllNotes] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const [newNote, setNewNote] = useState("");
  const {
    //data: noteData,
    isLoading: createNotePending,
    mutate: createReportNote,
  } = useCreateReportNote();

  const handleAddNote = async () => {
    setNewNote(newNote);
    createReportNote({
      report_uuid: report.report_uuid,
      note: newNote,
      actor_uuid: HARDCODED_ACTOR_UUID, // TODO: real actor uuid
    });
    setIsReportNoteModalOpen(false);
    setNewNote("");
  };

  const handleCancelNote = async () => {
    setIsReportNoteModalOpen(false);
    setNewNote("");
  };

  useEffect(() => {
    if (createNotePending) return;
    getNotes(report.report_uuid);
  }, [getNotes, report, createNotePending]);

  useEffect(() => {
    if (!notes) return;
    setShowReadMore(notes?.length > 1);
    setShowAllNotes(false);
  }, [setShowReadMore, notes]);

  if (!canAddNotes) {
    return <></>;
  }
  return (
    <>
      <div className="px-4 mt-4 min-w-0">
        <div className="flex justify-between items-start gap-2 min-w-0">
          <span
            className={classNames(
              "font-bold text-lg flex-1 pr-2",
              LONG_TEXT_WRAP_CLASSES
            )}
          >
            Notes
          </span>
          {!isReadOnly && (
            <Button
              text="Add"
              type={ButtonTypes.add}
              colorType={ButtonColorTypes.cancel}
              onClick={() => setIsReportNoteModalOpen(true)}
              className="shrink-0"
            />
          )}
        </div>
        {notesLoading ? (
          <div className="ml-4 p-2">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            {notes &&
              notes?.map((note, index) => {
                if (!showAllNotes && index > 0) return "";
                return <ReportNote key={index} Note={note} />;
              })}
            {showReadMore && (
              <button
                className="text-cyan-500 font-bold text-sm"
                onClick={() => setShowAllNotes(!showAllNotes)}
              >
                Show {showAllNotes ? "Less" : "More"}
              </button>
            )}
          </>
        )}
      </div>
      <Modal
        open={isReportNoteModalOpen}
        onClose={() => setIsReportNoteModalOpen(false)}
        width={"w-full max-w-lg p-0"}
      >
        <AddNoteModal
          note={newNote}
          onChange={(event) => setNewNote(event.target.value)}
          onCancel={handleCancelNote}
          onSubmit={handleAddNote}
        />
      </Modal>

      {createNotePending && <LoadingSpinner />}
    </>
  );
}

export default Notes;
